export default [
  "registration_fee_to_organiser",
  "starting_fee_to_organiser",
  "registration_fee_to_federation",
  "starting_fee_to_federation",
  "registration_fee_to_regional",
  "starting_fee_to_regional",
  "late_registration_fee",
  "cup_fee_to_federation",
  "cup_fee_to_regional",
  "event_product_price",
  "event_product_booking_fee"
];
